import { useSyncExternalStore } from "react";
import { API } from "./supabase";

let online = typeof navigator === "undefined" ? true : navigator.onLine;
let probeFailed = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
const effective = () => online && !probeFailed;

export const setOnline = (v) => { const before = effective(); online = v; if (v) probeFailed = false; if (before !== effective()) emit(); };

export const probe = async () => {
  if (!navigator.onLine) { online = false; emit(); return false; }
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), 3000);
  try {
    const r = await fetch(`${API}/health`, { method: "HEAD", cache: "no-store", signal: ctl.signal });
    const ok = r.ok || r.status < 500;
    const before = effective(); online = true; probeFailed = !ok; if (before !== effective()) emit();
  } catch { const before = effective(); probeFailed = true; if (before !== effective()) emit(); }
  finally { clearTimeout(t); }
  return effective();
};

if (typeof window !== "undefined") {
  window.addEventListener("online", () => { setOnline(true); probe(); });
  window.addEventListener("offline", () => setOnline(false));
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && probe());
  navigator.serviceWorker?.addEventListener?.("message", (e) => { if (e.data?.type === "OFFLINE_FALLBACK") { const b = effective(); probeFailed = true; if (b !== effective()) emit(); probe(); } });
  if (window.location.pathname !== "/v/demo-preview") probe();  // the demo page makes zero API calls
  setInterval(() => { if (!effective()) probe(); }, 15000);
}

export const useOnline = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, effective, () => true);

export const isNetworkError = (e) => !navigator.onLine || /fetch|network|Failed to fetch|Load failed|ECONN|timeout/i.test(e?.message || "") || e?.name === "TypeError";
